'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isVisibleInViewPort = isVisibleInViewPort;
exports.getCookie = getCookie;
exports.setCookie = setCookie;
exports.isCurrentUrl = isCurrentUrl;
exports.getTextFromPasteEvent = getTextFromPasteEvent;
exports.fixedEncodeURIComponent = fixedEncodeURIComponent;
exports.getScrollTop = getScrollTop;
exports.openPopUpWindow = openPopUpWindow;

var _cookie = require('cookie');

function isVisibleInViewPort(el) {
  var rect = el.getBoundingClientRect();
  return rect.top >= 0 || rect.bottom >= 0;
}

/**
 * Gets the value of the cookie at `key`.
 * @param  {string} key
 * @return {string}
 */
function getCookie(key) {
  if (!document) return undefined;
  return (0, _cookie.parse)(document.cookie)[key];
}

/**
 * Sets a document cookie with the given args.
 * @see https://github.com/jshttp/cookie#serialize
 *
 * @param {string} key
 * @param {string} val
 * @param {object} opts
 */
function setCookie(key, val, opts) {
  if (!document) return;
  document.cookie = (0, _cookie.serialize)(key, '' + val, opts);
}

var urlWithoutHash = function urlWithoutHash(url) {
  var hashIndex = url.lastIndexOf('#');
  return url.substring(0, hashIndex >= 0 ? hashIndex : url.length);
};

/**
 * Checks if the URL is the same as the browser's current URL
 *
 * @param {string} url
 */
function isCurrentUrl(url) {
  return urlWithoutHash(url) === urlWithoutHash(window.location.href);
}

function getTextFromPasteEvent(e) {
  if (e.clipboardData) {
    try {
      return e.clipboardData.getData('text/plain');
    } catch (err) {
      // IE11 does not support "text/plain", but does support "text".
      return e.clipboardData.getData('text');
    }
  }

  return null;
}

/**
 * Encodes additional special characters in the string value passed
 *
 * @param {string} str
 * Resource: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent
 */

function fixedEncodeURIComponent(str) {
  return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16);
  });
}

function getScrollTop() {
  if (window && document) {
    // See http://stackoverflow.com/questions/28633221/document-body-scrolltop-firefox-returns-0-only-js
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  }

  return 0;
}

/**
 * Opens a new pop up window when called.
 *
 * @param {object} { url, target, width, height }
 *
 */

function openPopUpWindow(_ref) {
  var url = _ref.url,
      _ref$target = _ref.target,
      target = _ref$target === undefined ? '_blank' : _ref$target,
      width = _ref.width,
      height = _ref.height;

  var leftScreenOffset = window.screenLeft || window.screenX;
  var topScreenOffset = window.screenTop || window.screenY;

  var left = Math.floor(leftScreenOffset + (window.outerWidth - width) / 2);
  var top = Math.floor(topScreenOffset + (window.outerHeight - height) / 2);

  var windowFeatures = {
    resizable: 1,
    status: 0,
    toolbar: 0,
    scrollbars: 1,
    location: 0,
    menubar: 0,
    width: width,
    height: height,
    left: left,
    top: top
  };

  windowFeatures = Object.keys(windowFeatures).map(function (attribute) {
    return attribute + '=' + windowFeatures[attribute];
  }).join(',');

  window.open(url, target, windowFeatures);
}


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/utils-browser/lib/index.js
// module id = 825
// module chunks = 0 3